import request from "@/utils/request";

// 分页查询
export function queryStashList(data) {
  return request({
    url: "/warehouse/page",
    method: "post",
    data,
  });
}

// 详情
export function queryStashById(id) {
  return request({
    url: `/warehouse/${id}`,
    method: "get",
  });
}

// 新增
export function insertStash(data) {
  return request({
    url: "/warehouse/save",
    method: "post",
    data,
  });
}

// 编辑
export function updateStash(data) {
  return request({
    url: "/warehouse/update",
    method: "post",
    data,
  });
}

// 批量删除
export function deleteStashByIds(ids) {
  return request({
    url: `/warehouse/removeBatchByIds/${ids}`,
    method: "delete",
  });
}

// 单个删除
export function deleteStashById(id) {
  return request({
    url: `/warehouse/delete/${id}`,
    method: "delete",
  });
}

// 获取仓库库存信息
export function getInventoryInfo(data) {
  return request({
    url: "/warehouse/inventory/info",
    method: "post",
    data,
  });
}
